import { Chart } from "@appretio/ui-kit";
import { ReviewDataResponse } from "../../../pages/inSeasonReviewPage/hooks/useFetchReviewData";
import { TrendLineResponse } from "../../../pages/inSeasonReviewPage/hooks/useFetchTrendLine";
import { chartWrapper } from "../Chart.css";
import { useAccuracyChartOptions } from "./hooks/useAccuracyChartOptions";

interface AccuracyChartProps {
  /**
   * Full dataset
   */
  inSeasonReviewData: ReviewDataResponse;
  /**
   * Trend line dataset
   */
  trendLineData: TrendLineResponse;
  /**
   * Loading state
   */
  isLoading: boolean;
}

export function AccuracyChart({
  inSeasonReviewData,
  trendLineData,
  isLoading
}: AccuracyChartProps) {
  const TITLE = "Accuracy chart";

  const { series, axes } = useAccuracyChartOptions({
    inSeasonReviewData,
    trendLineData
  });

  return (
    <div className={chartWrapper}>
      <Chart
        isLoading={isLoading}
        options={{
          title: { text: TITLE },
          series,
          axes,
          legend: {
            position: {
              placement: "right-top"
            }
          },
          zoom: {
            axes: "xy",
            enabled: inSeasonReviewData.length > 0,
            enableSelecting: true,
            anchorPointX: "pointer",
            anchorPointY: "pointer",
            panKey: "shift",
            autoScaling: {
              enabled: true
            }
          }
        }}
      />
    </div>
  );
}
